import { getRequest, postRequest, logRequest } from './api'

export async function list(size, index, searchTerm, orderBy) {
  // logRequest("Show User List")
  return getRequest(`users/get-list/${size || 15}/${index || 0}/${searchTerm || '%20'}/${orderBy || '%20'}`)
}

export async function find(id) {
  logRequest("Show User", JSON.stringify(id))
  return getRequest(`users/edit/${id}`)
}

export async function save(values) {
  logRequest("Save User")
  return postRequest(`users/save`, values)
}

export function remove(values) {
  logRequest("Delete User", JSON.stringify(values.values))
  return postRequest(`users/delete`, values)
}
